/**
 * This file is responsible for handling the service calls for the templates
 */
import store from "../store";
import {
	callAPI,
	chameau,
	DEFAULT_LIST_PARAMS,
	GATEWAY_PROXY,
	METHODS,
} from "utils/apiUtils";
import { FEATURE_FLAG, hasFeatureFlag } from "utils/LimitsAndFeatures";

export function listBluePrintsService(
	options = DEFAULT_LIST_PARAMS,
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: `${GATEWAY_PROXY}/campaign-blueprints`,
			method: METHODS.get,
			query: {
				...chameau(options),
				account_id: store.getState().global?.account?.id,
			},
		},
		(data)=>{
			//TODO removed after filter is added
			if(!options?.filter?.includes("smart")){
				//data.data = data.data.filter((t)=>!t.tags.includes("smart"));
			}

			successCallback(data);
		},
		failureCallback
	);
}

export function getBluePrintService(
	options = { bluePrintId: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	callAPI(
		{
			url: GATEWAY_PROXY + `/campaign-blueprints/${options.bluePrintId}`,
			method: METHODS.get,
			query: { account_id: store.getState().global?.account?.id },
		},
		successCallback,
		failureCallback
	);
}

export function renderBluePrintService(
	options = { bluePrintId: "" },
	successCallback = () => {},
	failureCallback = () => {}
) {
	const accountId = store.getState()?.global?.account?.id;
	let queryParam = {};
	if (accountId){
		queryParam = {account_id: accountId, brand_account_id : accountId};
	}
	callAPI(
		{
			url: GATEWAY_PROXY + `/campaign-blueprints/${options.bluePrintId}/render`,
			method: METHODS.get,
			query: queryParam,
		},
		successCallback,
		failureCallback
	);
}
